import http from '../../services/http';

const createPaymentUrl = async orderId => {
  const { url } = await http.get(`/api/client/createPayment?orderId=${orderId}`);
  return url;
};

export default {
  createPaymentUrl,
};
